import { ConnectAccountModal } from '@components/ConnectAccountModal/ConnectAccountModal';
import { AddRounded } from '@mui/icons-material';
import { ButtonBase } from '@mui/material';
import { useState } from 'react';
import css from './ConnectAccountCard.module.scss';

/**
 * The last card of the create page's account list: a dashed outline that
 * opens the connect modal, which comes back to this compose page with the
 * new account in the list.
 *
 * FIXME(publishing-connect-draft): the draft does not survive the round trip.
 * The connect is a full navigation, so whatever was typed is gone on return
 * and nothing warns before leaving; the render id in the URL restores the
 * page, not the form. Acceptable once, decided in #899: the card reads as a
 * way to an account, not as part of the form. Retire by keeping the draft
 * across the connect (or at least a warning before leaving) when the compose
 * page gets a persisted draft.
 */
export function ConnectAccountCard({ first }: { first: boolean }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <ButtonBase className={css.card} onClick={() => setOpen(true)}>
        <AddRounded className={css.icon} />
        <span className={css.label}>
          {first ? 'Connect an account' : 'Connect another account'}
        </span>
      </ButtonBase>
      <ConnectAccountModal open={open} onClose={() => setOpen(false)} source="compose" />
    </>
  );
}
